export default __webpack_public_path__ + "static/structural6-590a07bdc059f11efed93dee069de5a7.png";